module.exports = new __parcel__URL__("geoglam--dataset-cover.5ccaaec1.jpg").toString();